export const areTwoFieldsEqual = (field1: string, field2: string): boolean => {
  return field1 === field2;
};

export const isPasswordValid = (password: string): boolean => {
  const regularExpression = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
  return regularExpression.test(password);
};
